module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-t-mobile-intro-card1.1.0c8be603.jpg";